import Model from "./Model";

export type Profile = {
  slug: string;
  name: string;
};

export type Meta = {
  current_page: number;
  total_pages: number;
  total_count: number;
  prev_page: number | null;
  next_page: number | null;
};

export type NotificationInfo = {
  name: string;
  icon: string;
};

export enum Competitor {
  name = "Analisi concorrenza",
  icon = "concorrenza",
}

export enum Calendar {
  name = "Calendario",
  icon = "calendario",
}

export enum Spot {
  name = "Spot",
  icon = "spot",
}

export const NotificationTypes = {
  competitor: Competitor,
  calendar: Calendar,
  spot: Spot,
};

export type NotificationKinds = "competitor" | "calendar";

export type NotificationTargetTypes = "radio" | "tv";

// REMIND that radio and tv were "Radio" and "TV"

export type NotificationFormat = "sm" | "lg";

export type NotificationDurationTypes = "seconds" | "count";

export type NotificationStatus =
  | "todo"
  | "processing"
  | "ready"
  | "failed"
  | "read";

export default class Notification extends Model {
  static type = "reportJobs";

  status!: NotificationStatus;

  createdAt!: string;

  updatedAt!: string;

  type!: NotificationKinds;

  url!: string;

  profile!: Profile;

  startsAt!: string;

  endsAt!: string;

  durationType!: string;

  target!: NotificationTargetTypes;
}
